import { SkillStatesLabel } from '../models/SkillState';
import { StudentSkillStates } from '../models/StudentSkillState';
import { mapSkillStatus } from './mapSkillStatus';

export const chartAssignValues = (elements: StudentSkillStates[]) => {
  const chartValues: { [key: string]: number } = {
    Passed: 0,
    'Almost There': 0,
    'Keep Learning': 0,
    'Not Started': 0,
    Review: 0,
    'Placed Out': 0,
  };

  if (elements.length === 0) return { values: chartValues, percent: 0 };

  elements.forEach(el => {
    const elementStatus = mapSkillStatus(el.skillSubstate?.id, el.skillAssessment?.score);
    chartValues[String(elementStatus.status)]++;
  });
  const percent = Math.round(
    ((chartValues[SkillStatesLabel.PASSED] + chartValues[SkillStatesLabel.PLACED_OUT]) / elements.length) * 100,
  );
  return { values: chartValues, percent: percent };
};
